import React, { useState, useEffect, useRef } from 'react';
import { useInView } from 'react-intersection-observer';

// Single odometer digit column
function OdometerDigit({ target, delay, active }) {
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!active) return;
    const timer = setTimeout(() => setValue(target), delay + 100);
    return () => clearTimeout(timer);
  }, [active, target, delay]);

  return (
    <span
      className="inline-block overflow-hidden align-bottom"
      style={{ height: '1.15em', width: '0.62em' }}
    >
      <span
        className="flex flex-col transition-transform ease-out"
        style={{
          transform: `translateY(-${value * 10}%)`,
          transitionDuration: '1.2s',
          transitionTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)',
        }}
      >
        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => (
          <span
            key={n}
            className="block text-center"
            style={{ height: '1.15em', lineHeight: '1.15em' }}
          >
            {n}
          </span>
        ))}
      </span>
    </span>
  );
}

export default function RollingCounter({ end, suffix = '', prefix = '', className = '', autoStart = false, autoDelay = 0 }) {
  const { ref, inView } = useInView({ threshold: 0.05, triggerOnce: true });
  const [active, setActive] = useState(false);

  // Trigger via intersection observer
  useEffect(() => {
    if (inView && !active) {
      setActive(true);
    }
  }, [inView, active]);

  // Auto-trigger for hero stats (always visible on page load)
  useEffect(() => {
    if (autoStart && !active) {
      const timer = setTimeout(() => setActive(true), autoDelay);
      return () => clearTimeout(timer);
    }
  }, [autoStart, autoDelay, active]);

  const numStr = String(end);
  const chars = numStr.split('');

  return (
    <span ref={ref} className={className}>
      {prefix}
      {chars.map((d, i) => {
        const n = parseInt(d, 10);
        if (isNaN(n)) {
          return <span key={i}>{d}</span>;
        }
        return (
          <OdometerDigit
            key={i}
            target={n}
            delay={i * 80}
            active={active}
          />
        );
      })}
      {suffix}
    </span>
  );
}
